export default {"src":"/_next/static/media/reset.62a8c72b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};